import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { getAlertTypeMenuItems } from './helpers'

const AlertTypesSelector = ({ onChange, value = [], availableAlertTypes = [], loading }) => {
  const { t } = useTranslation()

  const handleChange = e => onChange(e.target.value)

  return (
    <div>
      <ComboBox
        menuItems={getAlertTypeMenuItems(availableAlertTypes, t)}
        value={value}
        multiple
        fullWidth
        label={t('Tipos de alerta')}
        loading={loading}
        handleChange={handleChange}
        placeholder={t('Tipos de alerta')}
      />
    </div>
  )
}

export default AlertTypesSelector
